import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-vulnerability',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './vulnerability.component.html',
  styleUrl: './vulnerability.component.scss'
})
export class VulnerabilityComponent {

}
